function revealCapacityCharts() {
  document.querySelectorAll('.capacity-chart').forEach((rootEl) => {
    rootEl.classList.add('capacity-chart--ready');
    rootEl.style.removeProperty('visibility');
  });
}

function scheduleReveal() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealCapacityCharts, { once: true });
    return;
  }

  revealCapacityCharts();
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-capacity-chart', revealCapacityCharts);
  }
});

scheduleReveal();
